var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InputField',{ref:"inputText",attrs:{"type":"text","field":_vm.fakeField},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }